import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DaoService } from '../servicos/dao.service';

@Component({
  selector: 'app-arquivo-info',
  templateUrl: './arquivo-info.component.html',
  styleUrls: ['./arquivo-info.component.css']
})
export class ArquivoInfoComponent implements OnInit {

  constructor(private route: ActivatedRoute, private dao:DaoService, private router: Router) { }

  categoria: string;
  private sub: any;
  acao:any;

  carregarArquivos(){
    if(this.categoria=='cadastro'){
        this.router.navigate(['/cadastro']);
    }
    
  }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      this.categoria = params['categoria']; // (+) converts string 'id' to a number

      // In a real app: dispatch action to load the details here.
      this.carregarArquivos();
    });
  }


}
